import { isPromotionMembershipsSingle } from './isPromotionMembershipsSingle';
import { isPromotionSingle } from './isPromotionSingle';
export const getPromotionTitle = (promotionData) => {
    if (promotionData) {
        return isPromotionSingle(promotionData) || isPromotionMembershipsSingle(promotionData)
            ? promotionData.code
            : promotionData.title;
    }
    return '';
};
